import { ReactNode } from "react";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import LoadingButton from "@mui/lab/LoadingButton";
import AppDialog, { DialogSize } from "../../shared/ui/AppDialog";

export type ReasonDialogProps = {
  title: string;
  context?: ReactNode;
  confirmLabel: string;
  confirmIcon?: ReactNode;
  destructive?: boolean;
  busy: boolean;
  error?: string | null;
  valid: boolean;
  size?: DialogSize;
  onConfirm: () => void;
  onClose: () => void;
  children?: ReactNode;
};

/** Casca das janelas de captura: AppDialog clássico, "Voltar" + botão principal desligado até ficar válido. */
export default function ReasonDialog({
  title,
  context,
  confirmLabel,
  confirmIcon,
  destructive = false,
  busy,
  error,
  valid,
  size = "md",
  onConfirm,
  onClose,
  children,
}: ReasonDialogProps) {
  return (
    <AppDialog
      open
      variant="classic"
      size={size}
      busy={busy}
      title={title}
      context={context}
      onClose={onClose}
      closeLabel="Fechar"
      actions={
        <>
          <Button onClick={onClose} disabled={busy} sx={{ color: "text.primary" }}>
            Voltar
          </Button>
          <LoadingButton
            variant="contained"
            color={destructive ? "error" : "primary"}
            loading={busy}
            disabled={!valid}
            startIcon={confirmIcon}
            onClick={onConfirm}
          >
            {confirmLabel}
          </LoadingButton>
        </>
      }
    >
      <Stack spacing={2}>
        {children}
        {error && <Alert severity="error">{error}</Alert>}
      </Stack>
    </AppDialog>
  );
}
